const styles = theme => ({
    "@keyframes placeHolderShimmer": {
        "0%": {
            backgroundPosition: "-100% 0",
        },
        "100%": {
            backgroundPosition: "100% 0",
        },
    },

    container: {
        width: "100%",
        height: "100%",

        "&:hover": {
            opacity: 0.7,
        },

        [theme.breakpoints.down("xs")]: {
            maxWidth: "100%",
        },
    },

    background: {
        animationDuration: "1s",
        animationFillMode: "forwards",
        animationIterationCount: "infinite",
        animationName: "placeHolderShimmer",
        animationTimingFunction: "linear",
        background: "linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%)",
        backgroundSize: "800px 104px",
        height: "100%",
        width: "100%",
        position: "relative",
    },

    placeholder: {
        position: "absolute",
        width: "50%",
        height: "50%",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        "z-index": "1",
        opacity: "0.5",
        fill: theme.palette.common.white,
    },
})

export default styles



// WEBPACK FOOTER //
// ./src/lib/components/ImageLoading/styles.js